import React from 'react';
import { Card, CardHeader, CardTitle } from './ui/Card';
import { AlertTriangle, TrendingUp, TrendingDown, Lightbulb, CheckCircle } from 'lucide-react';
import { clsx } from 'clsx';
export interface Insight {
  id: string;
  type: 'warning' | 'positive' | 'neutral' | 'critical';
  title: string;
  description: string;
  metric?: string;
}
interface InsightPanelProps {
  insights: Insight[];
}
export function InsightPanel({
  insights
}: InsightPanelProps) {
  const getIcon = (type: Insight['type']) => {
    switch (type) {
      case 'warning':
        return <AlertTriangle className="w-5 h-5 text-amber-500" data-id="element-75" />;
      case 'critical':
        return <AlertTriangle className="w-5 h-5 text-red-500" data-id="element-76" />;
      case 'positive':
        return <TrendingUp className="w-5 h-5 text-emerald-500" data-id="element-77" />;
      case 'neutral':
        return <Lightbulb className="w-5 h-5 text-blue-500" data-id="element-78" />;
      default:
        return <Lightbulb className="w-5 h-5 text-slate-500" data-id="element-79" />;
    }
  };
  const getBgColor = (type: Insight['type']) => {
    switch (type) {
      case 'warning':
        return 'bg-amber-50 border-amber-100';
      case 'critical':
        return 'bg-red-50 border-red-100';
      case 'positive':
        return 'bg-emerald-50 border-emerald-100';
      case 'neutral':
        return 'bg-blue-50 border-blue-100';
      default:
        return 'bg-slate-50 border-slate-100';
    }
  };
  return <Card className="h-full" data-id="element-80">
      <CardHeader data-id="element-81">
        <CardTitle className="flex items-center gap-2" data-id="element-82">
          <Lightbulb className="w-5 h-5 text-indigo-600" data-id="element-83" />
          Automated Insights
        </CardTitle>
      </CardHeader>
      <div className="space-y-4" data-id="element-84">
        {insights.map(insight => <div key={insight.id} className={clsx('p-4 rounded-lg border flex gap-4 items-start transition-all hover:shadow-sm', getBgColor(insight.type))} data-id="element-85">
            <div className="flex-shrink-0 mt-0.5" data-id="element-86">{getIcon(insight.type)}</div>
            <div data-id="element-87">
              <h4 className="text-sm font-semibold text-slate-900" data-id="element-88">
                {insight.title}
              </h4>
              <p className="text-sm text-slate-600 mt-1 leading-relaxed" data-id="element-89">
                {insight.description}
              </p>
              {insight.metric && <div className="mt-2 text-xs font-medium px-2 py-1 bg-white/50 rounded inline-block" data-id="element-90">
                  {insight.metric}
                </div>}
            </div>
          </div>)}

        {insights.length === 0 && <div className="text-center py-8 text-slate-500" data-id="element-91">
            <CheckCircle className="w-8 h-8 mx-auto mb-2 text-slate-300" data-id="element-92" />
            <p data-id="element-93">No critical insights detected for this period.</p>
          </div>}
      </div>
    </Card>;
}